export const BASE_URL = 'https://direct.dy-api.com/v2';
export const COLLECT_BASE_URL = 'https://direct-collect.dy-api.com/v2';

export const SLOT_CLICK = 'SLOT_CLICK';
export const CLICK = 'CLICK';

export const TIMEOUT_MS = 10000;
